import { Link, LinkProps, useNavigate } from "@remix-run/react";

import { BackArrowIcon } from "~/icons";

// import { cn } from "~/lib/utils";
import { Button } from "../ui";

export default function BackLink({ className, to, children }: LinkProps) {
    const navigate = useNavigate();
    return (
        <Button
            variant="action"
            className="self-start"
            onClick={() => {
                // TODO: Fix it so the to works with replace and doesn't require clicking back twice
                // if (to) {
                //     navigate(to, {
                //         replace: true,
                //     });
                // } else {
                navigate(-1);
                // }
            }}
        >
            <BackArrowIcon />
            <span>{children}</span>
        </Button>
    );
}
